import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import TableTopicsData from "../../../Pages/IndividualUnit/TableTopicsData";
import TopicDetailsModal from "../TopicDiscussedTab/TopicsDetailModal";
import TopicDiscussedTab from "../TopicDiscussedTab/TopicDiscussedTab";
import WeekSelector from "../TopicDiscussedTab/WeekSelector";
import axios from "axios";
import { each } from "highcharts";
import { Card, CardBody, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";

const WebinarInsightsTab = ({ resetTrigger, fullURL, payload, setpayload, isApiLoading }) => {
  const [activeSubtab, setActiveSubtab] = useState('Topics Covered');
  const [selectedWeeks, setSelectedWeek] = useState(null);
  const [weeks, setWeeks] = useState({});

  const [fullTopicData, setFullTopicData] = useState({}); // This will hold the raw data from API, including Q&A

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState('');

  const [weekPeriod, setweekPeriod] = useState(null);

  const [tableDisplayData, setTableDisplayData] = useState([]); // This will hold data for the table
  const [tableQueiriesDisplayData, settableQueiriesDisplayData] = useState([]); // This will hold data for the table
  const [tableissuesDisplayData, settableissuesDisplayData] = useState([]);
  const [summaryAllTopics, setSummaryTopics] = useState("");
  const [tableTopicsCoveredDisplayData, settableTopicsCoveredDisplayData] =
    useState([]); // This will hold data for the table
  const [loading, setloading] = useState(false);
  const user_token = localStorage.getItem('usertoken');

  useEffect(() => {
    // Reset states when resetTrigger changes
    setOpenModal(false);
    setWeeks({});
    setSelectedWeek(null);
    setweekPeriod(null);
    setTableDisplayData([]);
    settableQueiriesDisplayData([]);
    settableTopicsCoveredDisplayData([]);
    settableissuesDisplayData([]);
    setFullTopicData({});
    setSummaryTopics("")
  }, [resetTrigger]);

  useEffect(() => {
    if (!selectedWeeks) {
      setTableDisplayData([]);
      setweekPeriod(null);
      settableQueiriesDisplayData([]);
      settableTopicsCoveredDisplayData([]);
      settableissuesDisplayData([]);
      setFullTopicData({});
      setSummaryTopics("")
    }
  }, [selectedWeeks]);

  useEffect(() => {
    setWeeks({});
  }, [fullURL]);

  useEffect(() => {
    console.warn('selectedWeeks', selectedWeeks);
    if (selectedWeeks) {
      fetchTableData();
    }
  }, [selectedWeeks, payload]);

  const fetchTableData = async () => {
    setweekPeriod(null);
    setloading(true);
    if (!payload || Object.keys(payload).length === 0) return;
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    try {
      const tableres = await axios.post(fullURL, {
        ...payload,
        mode: 'webinar_insights',
        week: selectedWeeks.label,
      }, config);

      console.warn(tableres);
      // settableQueiriesDisplayData(tableres?.queries);
      settableTopicsCoveredDisplayData(tableres?.topics);

      settableissuesDisplayData(
        tableres?.issues,
      );
      setSummaryTopics(tableres?.summary || "")
      // console.warn([tableres?.issues?.map((each) => ({ issue: each }))]);
      if (tableres) {
        setFullTopicData(tableres.topics);
        setweekPeriod(tableres.week);
        console.warn({ tableres })
        const transformedData = Object.keys(tableres.topics).map(
          (topicName, index) => {
            const questions = tableres.topics[topicName];
            const studentCount = questions.reduce(
              (sum, item) => sum + item.student_count,
              0,
            );
            const questionsCount = questions.length;

            return {
              id: index + 1,
              topicName: topicName,
              Noofstudentsasked: tableres.topics[topicName].total_students || "N/A",
              // Noofstudentsasked: "N/A",
              Noofquestionsasked: questionsCount,
            };
          },
        );

        const sortedData = transformedData.sort(
          (a, b) => b.Noofstudentsasked - a.Noofstudentsasked,
        );
        console.warn({ sortedData })
        setTableDisplayData(sortedData);
      }
    } catch (error) {
      console.warn('Error fetching table data:', error);
      setTableDisplayData([]);
      setFullTopicData({});
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    console.warn('payload', payload);
    const fetchWeeks = async () => {
      if (!payload || Object.keys(payload).length === 0) return;
      let config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      try {
        const weekres = await axios.post(fullURL, {
          ...payload,
          week: null,
          mode: 'webinar_insights',
        }, config);
        if (weekres && weekres && weekres.weeks) {
          setWeeks(weekres.weeks);
        }
      } catch (error) {
        console.error('Error fetching weeks:', error);
      }
    };

    fetchWeeks();
  }, [fullURL, payload]);

  const toggleSubTab = (tab) => {
    setActiveSubtab(tab);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent([]);
    setModalTitle('');
  };

  const handleTopicClick = (topicName) => {
    const topicDetails = fullTopicData[topicName];
    setModalContent(topicDetails);
    setModalTitle(topicName);
    setOpenModal(true);
  };

  // Column schema works

  // const schemaQueriesraised = [
  //   {
  //     field: 'sno',
  //     headerName: 'S.No',
  //     width: 80,
  //     headerAlign: 'center',
  //     align: 'center',
  //     sortable: false,
  //   },
  //   {
  //     field: 'query',
  //     headerName: 'Query',
  //     width: 700,
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  //   {
  //     field: 'response',
  //     headerName: 'Response',
  //     width: 800,
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  // ];

  // const schemaTopicsCovered = [
  //   {
  //     field: 'sno',
  //     headerName: 'S.No',
  //     width: 80,
  //     headerAlign: 'center',
  //     align: 'center',
  //     sortable: false,
  //   },
  //   {
  //     field: 'topic',
  //     headerName: 'Topic',
  //     width: 700,
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  //   {
  //     field: 'summary',
  //     headerName: 'Summary',
  //     width: 800,
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  // ];

  // const schemaStudentIssues = [
  //   {
  //     field: 'sno',
  //     headerName: 'S.No',
  //     width: 80,
  //     headerAlign: 'center',
  //     align: 'center',
  //     sortable: false,
  //   },
  //   {
  //     field: 'issue',
  //     headerName: 'Issue',
  //     width: 1000,
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  // ];

  // Chat gpt code for updated for responsiveness

  const schemaTopicsCovered = [
    {
      field: 'sno',
      headerName: 'S.No',
      flex: 0.3,
      headerAlign: 'left',
      align: 'center',
      sortable: false,
    },
    {
      field: 'topicName',
      headerName: 'Topic',
      flex: 1.2,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(params.value),
          }}
        />
      ),
    },
    {
      field: 'Noofstudentsasked',
      headerName: 'No of Students Asked',
      width: 230,
      headerAlign: 'left',
      align: 'center',
    },
    {
      field: 'Noofquestionsasked',
      headerName: 'No of Times Discussed',
      width: 230,
      headerAlign: 'left',
      align: 'center',
    },
  ];
  // const schemaStudentIssues = [
  //   {
  //     field: 'sno',
  //     headerName: 'S.No',
  //     flex: 0.2,
  //     headerAlign: 'left',
  //     align: 'center',
  //     sortable: false,
  //   },
  //   {
  //     field: 'issue',
  //     headerName: 'Issue',
  //     flex: 2,
  //     headerAlign: 'left',
  //     align: 'left',
  //     renderCell: (params) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: DOMPurify.sanitize(params.value),
  //         }}
  //       />
  //     ),
  //   },
  // ];


  useEffect(() => {
    console.warn(tableDisplayData)

  }, [tableDisplayData])



  return (
    <Row className="g-2 mb-2">
      <div className="ind-teacher-report-tab">
        <Card className="mb-0" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
          <CardBody style={{ minHeight: '200px' }}>
            <div class="col-12">
              <div className="d-flex align-items-center">
                <div>
                  {weekPeriod && (
                    <p className="mb-2">
                      Week Period :
                      <strong className="ml-1" style={{ marginLeft: '5px' }}>
                        {weekPeriod ? weekPeriod : 'N/A'}
                      </strong>
                    </p>
                  )}
                </div>
                <div className="ms-auto">
                  <WeekSelector
                    weeks={weeks}
                    selectedWeeks={selectedWeeks}
                    setSelectedWeek={setSelectedWeek}
                  />
                </div>
              </div>

              <div>
                <>
                  {selectedWeeks && (
                    <Nav tabs>

                      <NavItem>
                        <NavLink
                          className={
                            activeSubtab === 'Topics Covered' ? 'active' : ''
                          }
                          active={activeSubtab === 'Topics Covered'}
                          onClick={() => toggleSubTab('Topics Covered')}
                          style={{
                            cursor: 'pointer',
                            marginRight: '3px',
                          }}
                        >
                          Topics Covered
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={
                            activeSubtab === 'Student Issues' ? 'active' : ''
                          }
                          active={activeSubtab === 'Student Issues'}
                          onClick={() => toggleSubTab('Student Issues')}
                          style={{
                            cursor: 'pointer',
                            marginRight: '3px',
                          }}
                        >
                          Student Issues
                        </NavLink>
                      </NavItem>
                    </Nav>
                  )}
                  {selectedWeeks ? (
                    <>

                      {activeSubtab === 'Topics Covered' && (
                        <>
                          <TableTopicsData
                            noRowsLabel={'No Topics Covered for This Week'}
                            topicsData={tableDisplayData}
                            onTopicClick={handleTopicClick}
                            columns={schemaTopicsCovered}
                          />



                          {/* <TopicDiscussedTab
                          resetTrigger={resetTrigger}
                          fullURL={
                            process.env.REACT_APP_API_BASE_URL +
                            'individual_unit_report/'
                          }
                          payload={payload}



                        /> */}

                        </>
                      )}
                      {activeSubtab === 'Student Issues' && (
                        <div className="row mt-2">
                          <div className="col-md-12 ">
                            {
                               Object.keys(tableissuesDisplayData || {}).length > 0 ?
                            Object.keys(tableissuesDisplayData).map((topic, index) => (
                              <div key={index} className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light">
                                <h6 className="fw-bold  mb-2">{topic}</h6>
                                <ul className="list-group-item-info ps-3">
                                  {tableissuesDisplayData[topic].map((issue, issueIndex) => (
                                    <li key={issueIndex} className="mb-1 text-dark">
                                      <i className="bi bi-dot me-2 text-secondary"></i>{issue}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )) : <p className="ms-3">No Student Issues Available</p>}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div>
                      <p class="text-muted w-100 mt-3 text-center">
                        Please Select the week to view Webinar Insights
                      </p>

                    </div>
                  )}
                </>
              </div>
            </div>

            <TopicDetailsModal
              open={openModal}
              onClose={handleCloseModal}
              title={modalTitle}
              contentDetails={modalContent}
            />
          </CardBody>
        </Card>
      </div>
    </Row>
  );
};

export default WebinarInsightsTab;
